import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button", "fade"]

  toggle() {
    const isExpanded = this.contentTarget.classList.contains('task-description-expanded')
    
    if (isExpanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.contentTarget.classList.remove('task-description-clamped')
    this.contentTarget.classList.add('task-description-expanded')
    
    if (this.hasFadeTarget) {
      this.fadeTarget.style.display = 'none'
    }
    
    this.buttonTarget.textContent = '← Show less'
  }

  collapse() {
    this.contentTarget.classList.remove('task-description-expanded')
    this.contentTarget.classList.add('task-description-clamped')
    
    if (this.hasFadeTarget) {
      this.fadeTarget.style.display = 'block'
    }
    
    this.buttonTarget.textContent = 'Read more →'
  }
}
